module.exports = __webpack_public_path__ + "static/media/screenshot1.011c4bd6.png";